import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets window scroll position to (0, 0) on every
 * client-side route change. Preserves scroll for in-page anchor links
 * (e.g. /#priser) by only resetting when the pathname actually changes,
 * not when hash or search change.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}
